
import { Component, Mixins, Prop } from "vue-property-decorator";
import { DocumentInjectedEvidenceText } from "../../../../../../../domain/document";
import InjectedObjectEvidencePresentableMixin from "./InjectedObjectEvidencePresentableMixin.vue";

@Component
export default class InjectedObjectEvidenceTextPresentableMixin extends Mixins(InjectedObjectEvidencePresentableMixin) {
  @Prop()
  source: DocumentInjectedEvidenceText;

  get text(): string {
    return this.source.text;
  }
}
